import { Button, message, Upload, Image } from "antd";
import React, { useState, useEffect } from "react";
import { CloseCircleFilled, UploadOutlined } from "@ant-design/icons";
import { uploadFile, deleteFile } from "react-s3";
import { s3Config } from "../config/s3Config";
import { getFileExtension } from "../helper/functions";
import { uploadToS3 } from "../helper/s3";

const FileType = [
  "image/png",
  "image/jpg",
  "image/jpeg",
  "image/avif",
  "image/webp",
  // "image/gif",
];

const ProfileUpload = ({
  fileType = FileType,
  value,
  imageType,
  btnName,
  onChange,
  size = 1,
  isDimension = false,
  ...props
}) => {
  const [file, setFile] = useState([]);
  const [fileInfo, setFileInfo] = useState(null);

  const handleImgChange = async (event) => {
    const { file } = event;
    setFile([file]);
    const extension = getFileExtension(file.name);
    const name = `sojo_${new Date().getTime()}.${extension}`;

    const newFile = new File([file], name, { type: file.type });

    //  await uploadToS3({file:newFile,type:imageType})

    uploadToS3({ file: newFile, type: imageType })
      .then((data) => {
        console.log("File Upload", newFile, data);
        const fileData = {
          uid: file.uid,
          name: name,
          status: "done",
          url: data.location,
          thumbUrl: data.location,
        };
        setFile([fileData]);
        setFileInfo({
          name: file.name,
          size: (file.size / (1024 * 1024)).toFixed(2),
          type: file.type,
        });
        if (onChange) {
          onChange([fileData]);
        }
      })
      .catch((err) => console.error(err));

    /*  uploadFile(newFile, s3Config(imageType))
            .then((data) => {
              console.log("File Upload", newFile, data);
              const fileData = {
                uid: file.uid,
                name: name,
                status: "done",
                url: data.location,
                thumbUrl: data.location,
              };
              setFile([fileData]);
              if (onChange) {
                onChange([fileData]);
              }
            })
            .catch((err) => console.error(err)); */
  };

  const checkImageDimensions = (file) => {
    return new Promise((resolve, reject) => {
      const img = document.createElement("img");

      img.onload = () => {
        if (img.width === 720 && img.height === 480) {
          resolve();
        } else {
          reject(
            `Please upload an image with dimensions 720 X 480. uploaded image is ${img.width} X ${img.height}`
          );
        }
      };

      img.src = URL.createObjectURL(file);
    });
  };

  const beforeUpload = (file) => {
    if (fileType.includes(file.type)) {
    } else {
      message.error("File format is not correct");
      return false;
    }
    const isLt2M = file.size / 1024 / 1024 < 5;

    if (!isLt2M) {
      message.error(`Image must be smaller than 5 MB!`);
      return false;
    }
    return true;
  };

  const Delete = (filename, imageType) => {
    deleteFile(filename, s3Config(imageType))
      .then((response) => console.log(response))
      .catch((err) => console.error(err));
  };

  const onRemove = (fileToRemove) => {
    console.log("Removing file:", fileToRemove);

    const filename = fileToRemove.name;

    if (filename) {
      Delete(filename, imageType);
    }

    setFile([]);
    setFileInfo(null);

    if (onChange) {
      onChange([]);
    }
  };

  useEffect(() => {
    if (!value || value.length === 0) {
      setFile([]);
    } else {
      // Ensure preview is restored when editing
      setFile(value);
    }
  }, [value]);

  return (
    <>
      {/* <Upload
        listType="picture"
        maxCount={1}
        beforeUpload={beforeUpload}
        customRequest={handleImgChange}
        onRemove={onRemove}
        fileList={file}
        {...props}
      >
        {file && file.length > 0 && file !== "" ? null : (
          <Button icon={<UploadOutlined />}>
            {" "}
            {btnName ? `Upload ${btnName}` : ""}
          </Button>
        )}
      </Upload> */}
      {/* {
                fileInfo && (
                    <div className="image-info mt-2">
                        <p><strong>File:</strong> {fileInfo.name}</p>
                        <p><strong>Size:</strong> {fileInfo.size} MB</p>
                        <p><strong>Format:</strong> {fileInfo.type}</p>
                    </div>
                )
            } */}
      <div
        style={{
          position: "relative",
          width: 120,
          height: 120,
          margin: "0 auto",
        }}
      >
        <Upload
          showUploadList={false}
          beforeUpload={beforeUpload}
          customRequest={handleImgChange}
          onRemove={onRemove}
          fileList={file}
          maxCount={1}
        >
          <div
            style={{
              width: 120,
              height: 120,
              borderRadius: "50%",
              overflow: "hidden",
              border: "2px solid #ddd",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#f9f9f9",
            }}
          >
            {file.length > 0 ? (
              <img
                src={file[0].url}
                alt="Uploaded"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            ) : (
              <div style={{ color: "#aaa", fontSize: 12 }}>Click to Upload</div>
            )}
          </div>
        </Upload>

        {file.length > 0 && (
          <div
            onClick={() => onRemove(file[0])}
            className="profile-remove-cross"
          >
            <CloseCircleFilled />
          </div>
        )}
      </div>
    </>
  );
};

export default ProfileUpload;
